// extracted by mini-css-extract-plugin
export default {"linkTitle":"TeamsLink_linkTitle__42Dnd"};